import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Typography, 
  Box, 
  Container,
  Paper,
  IconButton
} from '@mui/material';
import * as Icons from '@mui/icons-material';

function TelegramMessages() {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      py: 6 
    }}>
      <Container maxWidth="lg">
        <Paper elevation={0} sx={{ 
          p: 2, 
          mb: 4, 
          background: 'transparent', 
          display: 'flex',
          alignItems: 'center'
        }}>
          <IconButton onClick={() => navigate('/telegram')} sx={{ color: 'white', mr: 2 }}>
            <Icons.ArrowBack />
          </IconButton>
          <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'white', m: 0 }}>
            Messaggi Telegram
          </Typography>
        </Paper>
        <Typography sx={{color: 'white'}}>
          Questa sezione è in costruzione.
        </Typography>
      </Container>
    </Box>
  );
}

export default TelegramMessages;
